import Vue from 'vue'
import VueSweetalert2 from 'vue-sweetalert2'
// Si no necesita los estilos, no conecte 
import  'sweetalert2/dist/sweetalert2.min.css' ;

Vue.use(VueSweetalert2)
